<template>
  <main class="physical-order-page">
    <AppNavBar :title="t('card.applyPhysicalCard')" />
    <div class="card-type-switch-wrap">
      <div class="card-type-switch">
        <button
          v-for="item in cardTypeTabs"
          :key="item.type"
          type="button"
          :class="{ active: item.type === 1 }"
          @click="switchCardType(item.type)"
        >
          {{ item.title }}
        </button>
      </div>
    </div>
    <section class="empty-card">
      <app-image :src="physicalEmpty" alt="" />
      <h2>{{ t("card.physicalCard") }}</h2>
      <p>{{ t("card.physicalDesc") }}</p>
      <van-button
        round
        block
        :class="'empty-card__action-type'"
        @click="goNext"
        >{{ t("card.applyCard") }}</van-button
      >
    </section>
    <!-- <div class="card-type-switch">
      <button
        v-for="item in cardTypeTabs"
        :key="item.type"
        type="button"
        :class="{ active: item.type === 1 }"
        @click="switchCardType(item.type)"
      >
        {{ item.title }}
      </button>
    </div>

    <section class="hero-card">
      <div class="hero-card__head">
        <span>{{ t('card.physicalCard') }}</span>
        <div data-strong>{{ t('card.applyPhysicalCard') }}</div>
        <p>{{ t('card.physicalApplyDesc') }}</p>
      </div>
      <app-image class="hero-card__bg" src="@/assets/images/cardImage/card_three.png" alt="" />
    </section>

    <section v-if="templates.length" class="template-card">
      <header>
        <h2>{{ t('card.selectCardTemplate') }}</h2>
        <span>{{ currentTemplateIndex + 1 }}/{{ templates.length }}</span>
      </header>

      <van-swipe :loop="false" :show-indicators="templates.length > 1" @change="onSwipeChange">
        <van-swipe-item v-for="(item, index) in templates" :key="item.templateId || index">
          <article class="template-preview">
            <app-image src="@/assets/images/cardImage/card_three.png" alt="" />
            <div class="template-preview__status">{{ t('card.shippingFree') }}</div>
            <div class="template-preview__meta">
              <div data-strong>{{ item.name || item.templateName || t('card.physicalCard') }}</div>
              <span>{{ t('card.cardType') }}: {{ t('card.physicalCard') }}</span>
            </div>
          </article>
        </van-swipe-item>
      </van-swipe>

      <div class="price-row">
        <span>{{ t('card.applicationFee') }}</span>
        <div data-strong>{{ payAmount }} {{ paySymbol }}</div>
      </div>

      <van-cell :title="t('card.cardType')" :value="t('card.physicalCard')" />
      <van-cell :title="t('card.shippingFee')" :value="t('card.shippingFree')" />
      <van-cell :title="t('card.recentTradeScene')" :value="t('card.physicalSceneDesc')" />
    </section>

    <section class="tips-card">
      <h2>{{ t('card.physicalOrderNotice') }}</h2>
      <ol>
        <li>{{ t('card.physicalNotice1') }}</li>
        <li>{{ t('card.physicalNotice2') }}</li>
        <li>{{ t('card.physicalNotice3') }}</li>
      </ol>
    </section>

    <van-button block round type="primary" class="submit-btn" :loading="submitting" @click="goNext">
      {{ t('card.fillShippingInfo') }}
    </van-button> -->
  </main>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { showFailToast, showToast } from "vant";
import { useI18n } from "vue-i18n";
import { useRouter } from "vue-router";
import { cardMyList, pcCardCreatePre, pcCardTemplateList } from "@/api/card";
import { useCardOrderStore } from "@/stores/card-order";
import { useProfileStore } from "@/stores/profile";
import { getDeviceId } from "@/utils/device";
import { navigateWithState } from "@/utils/route-state";
import physicalEmpty from "@/assets/images/cardImage/card2_eg.png";

const { t } = useI18n();
const router = useRouter();
const cardOrderStore = useCardOrderStore();
const profileStore = useProfileStore();

const templates = ref([]);
const holderStatus = ref(0);
const rejectReason = ref("");
const currentTemplateIndex = ref(0);
const submitting = ref(false);

const currentTemplate = computed(
  () => templates.value[currentTemplateIndex.value] || {},
);
const cardTypeTabs = computed(() => [
  { type: 2, title: t("card.virtualCard") },
  { type: 1, title: t("card.physicalCard") },
]);
const payAmount = computed(() => {
  const openAmount = Number(currentTemplate.value.openAmount || 0);
  const openChargeAmount = Number(currentTemplate.value.openChargeAmount || 0);
  return (openAmount + openChargeAmount).toFixed(2).replace(/\.00$/, "");
});
const paySymbol = computed(() => currentTemplate.value.openSymbol || "USD");

function onSwipeChange(index) {
  currentTemplateIndex.value = index;
}

function switchCardType(type) {
  if (Number(type) === 1) return;
  navigateWithState(router, "/wallet/open-card", {
    namespace: "card-open",
    payload: {
      type: "2",
    },
  });
}

async function loadData() {
  try {
    const [templateResult, preResult] = await Promise.all([
      pcCardTemplateList({
        address: profileStore.platformAddress || null,
        cardType: 1,
      }),
      pcCardCreatePre({ address: profileStore.platformAddress || null }),
    ]);
    templates.value = Array.isArray(templateResult?.list)
      ? templateResult.list
      : [];
    holderStatus.value = Number(preResult?.holderStatus || 0);
    rejectReason.value = String(preResult?.reason || "").trim();
  } catch (error) {
    templates.value = [];
    rejectReason.value = "";
  }
}

async function goNext() {
  if (!profileStore.platformAddress) {
    router.push("/login");
    return;
  }

  if (Number(holderStatus.value) !== 3) {
    if (
      holderStatus.value === 2 ||
      holderStatus.value === 4 ||
      (holderStatus.value === 1 && rejectReason.value)
    ) {
      navigateWithState(router, "/card/kyc/result", {
        namespace: "card-kyc-result",
        payload: {
          holderStatus: String(holderStatus.value || 1),
          reason: rejectReason.value,
          type: "1",
        },
      });
      return;
    }
    router.push("/card/kyc");
    return;
  }

  if (!currentTemplate.value?.templateId) {
    showFailToast(t("card.selectCardTemplate"));
    return;
  }

  submitting.value = true;
  try {
    const result = await cardMyList({
      address: profileStore.platformAddress,
      pageNum: 1,
      pageSize: 999,
      deviceToken: getDeviceId(),
      cardType: 2,
    });
    const virtualCards = (
      Array.isArray(result?.list) ? result.list : []
    ).filter((item) => item?.physical === false);
    cardOrderStore.mergeDraft({
      template: currentTemplate.value,
      templateId: String(currentTemplate.value.templateId),
      cardPrice: String(payAmount.value),
      cardPriceSymbol: paySymbol.value,
      virtualCardData: virtualCards,
      currentCardInfo: virtualCards[0] || {},
    });
    router.push("/card/physical-order/address");
  } catch (error) {
    showFailToast(error.message || error.msg || t("common.retryLater"));
  } finally {
    submitting.value = false;
  }
}

onMounted(() => {
  navigateWithState(router, "/wallet/open-card", {
    namespace: "card-open",
    replace: true,
    payload: {
      type: "1",
    },
  });
});
</script>

<style scoped lang="scss">
.physical-order-page {
  height: var(--app-viewport-height);
  min-height: var(--app-viewport-height);
  overflow-y: auto;
  overscroll-behavior: contain;
  -webkit-overflow-scrolling: touch;
  padding: 14px 14px 34px;
  background: #f7f7f7;
}

.card-type-switch-wrap {
  position: sticky;
  top: calc(var(--van-nav-bar-height) + env(safe-area-inset-top) - 14px);
  z-index: 20;
  margin: 0 -14px;
  padding: 12px 14px;
  background: #ffffff;
  border-bottom: 1px solid #fff;
}

.card-type-switch {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0;
  padding: 3px;
  border-radius: 20px;
  background: #eaeaea;

  button {
    height: 36px;
    border: 0;
    border-radius: 18px;
    background: transparent;
    color: #000000;
    font-size: 15px;
  }

  button.active {
    background: #ffffff;
  }
}

.hero-card,
.template-card,
.tips-card {
  border-radius: 8px;
  background: #ffffff;
}

.empty-card {
  min-height: 560px;
  text-align: center;
  padding-top: 80px;

  .app-image {
    width: 60%;
    max-width: 230px;
    margin: 0 auto 18px;
  }

  h2 {
    margin: 0;
    color: var(--wp-color-text);
    font-size: 22px;
    font-weight: 700;
  }

  p {
    margin: 12px 0 22px;
    color: #777777;
    font-size: 14px;
  }
}

.empty-card__action-type {
  height: 44px;
  border: 0;
  background: #eaeaea;

  :deep(.van-button__text) {
    color: #999;
    font-size: 16px;
    font-weight: bold;
  }
}

.hero-card {
  position: relative;
  overflow: hidden;
  padding: 20px 18px 150px;
  background: linear-gradient(135deg, #1548d4, #3f7cff);
  color: #ffffff;
}

.hero-card__head {
  position: relative;
  z-index: 1;

  span,
  [data-strong],
  p {
    display: block;
  }

  span {
    font-size: 13px;
  }

  [data-strong] {
    margin-top: 8px;
    font-size: 24px;
    line-height: 32px;
  }

  p {
    max-width: 210px;
    margin: 8px 0 0;
    font-size: 13px;
    line-height: 20px;
  }
}

.hero-card__bg {
  position: absolute;
  right: 12px;
  bottom: 12px;
  width: 180px;
}

.template-card {
  margin-top: 10px;
  padding: 18px 0 8px;

  > header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 16px 12px;

    h2,
    span {
      margin: 0;
    }

    h2 {
      color: var(--wp-color-text);
      font-size: 16px;
      font-weight: 500;
    }

    span {
      color: var(--wp-color-sub-text);
      font-size: 12px;
    }
  }
}

.template-preview {
  position: relative;
  margin: 0 12px;

  .app-image {
    display: block;
    width: 100%;
  }
}

.template-preview__status {
  position: absolute;
  top: 0;
  right: 0;
  padding: 6px 12px;
  border-radius: 0 12px 0 12px;
  background: #1e866e;
  color: #f1fffc;
  font-size: 12px;
}

.template-preview__meta {
  position: absolute;
  left: 18px;
  right: 18px;
  bottom: 20px;
  color: #ffffff;

  [data-strong],
  span {
    display: block;
  }

  [data-strong] {
    font-size: 18px;
    font-weight: 500;
  }

  span {
    margin-top: 6px;
    font-size: 13px;
    opacity: 0.92;
  }
}

.price-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 18px 16px 10px;

  span {
    color: #333333;
    font-size: 14px;
  }

  [data-strong] {
    color: var(--van-primary-color);
    font-size: 22px;
    font-weight: 700;
  }
}

.tips-card {
  margin-top: 10px;
  padding: 18px 16px;

  h2 {
    margin: 0 0 12px;
    color: var(--wp-color-text);
    font-size: 16px;
    font-weight: 500;
  }

  ol {
    padding-left: 18px;
    margin: 0;
    color: #333333;
    font-size: 13px;
    line-height: 21px;
  }

  li + li {
    margin-top: 8px;
  }
}

.submit-btn {
  margin-top: 24px;
}
</style>
